import React from 'react';
import { useEffect } from 'react';
import { useHospitalProfileStore } from "@/lib/stores/hospitalProfile";
import { PageContextProvider } from './PageContextProvider';

interface AppWrapperProps {
  children: React.ReactNode;
}

export const AppWrapper: React.FC<AppWrapperProps> = ({ children }) => {
  const fetchProfile = useHospitalProfileStore((state) => state.fetchProfile);

  useEffect(() => {
    fetchProfile();
  }, [fetchProfile]);

  return (
    <PageContextProvider>
      {children}
    </PageContextProvider>
  );
}; 